import { useEffect } from "react";
import QueryString from "query-string";
import { useLocation } from "react-router";
import useSubscriptions from "./useSubscriptions";
import { toCategoriesAndTags } from "./useSubscriptions.helpers";
import { getSubscriptionTagsByCategory } from "./getSubscriptionsByCategory";
import { useGetSectorData } from "../../../pages/redesign/menuFilterBar/api/getSectorData";
import { useGetPreferences } from "../../../api/preferences/useGetPreferences";
import { PUB_LANG } from "../../../redux/slices/api/initialisePreferences";

export const SUBSCRIBE_DEEP_LINK_PARAM = "subscribe";

export function useSubscriptionDeepLink() {
  const { search } = useLocation();
  const sectorData = useGetSectorData();
  const reportLang = useGetPreferences(PUB_LANG);
  const {
    setPendingSubscribePubId,
    setIsSubscriptionFromPillsBar,
    setSelectedPub,
    setSelectedSubscriptionTags,
    setSelectedLanguages,
    setSubscriptionName,
    setModalShow,
  } = useSubscriptions();

  useEffect(() => {
    const qs = QueryString.parse(search);
    if (qs[SUBSCRIBE_DEEP_LINK_PARAM] !== "true") return;

    if (qs.q) {
      // report-card link: wait for the matching card to render
      setPendingSubscribePubId(String(qs.q));
      return;
    }

    // filter-based link: open modal immediately with current URL filters
    const { [SUBSCRIBE_DEEP_LINK_PARAM]: _ignored, ...filterQs } = qs;
    const categoriesAndTags = toCategoriesAndTags(filterQs, sectorData);
    const pub = { id: "from-qs", tagsByCategory: categoriesAndTags };
    const tags = Object.values(getSubscriptionTagsByCategory(pub)).flat();

    setIsSubscriptionFromPillsBar(true);
    setSelectedPub(pub);
    setSelectedSubscriptionTags(tags);
    setSelectedLanguages(reportLang);
    setSubscriptionName("");
    setModalShow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
